import layout from './header-side'

export default layout